<div class="regras-produto">

  <app-regras-toolbar
    [busca]="busca"
    [filtroAtivo]="filtroAtivo"
    [situacaoOptions]="filtroSituacaoOptions"
    [carregando]="loading"
    placeholder="Código de origem, produto ou descrição"
    rotuloNovo="Novo de-para"
    classeBusca="po-md-3"
    (buscar)="filtrar($event)"
    (filtrarSituacao)="onFiltroSituacao($event)"
    (atualizar)="carregar()"
    (novo)="abrirNova()">

    <po-select
      extraFiltro
      class="po-md-3"
      p-label="Tipo"
      [p-options]="filtroTipoOptions"
      [ngModel]="filtroTipo"
      (p-change)="onFiltroTipo($event)"
      [ngModelOptions]="{ standalone: true }"
      name="filtroTipo">
    </po-select>
  </app-regras-toolbar>

  <app-regras-skeleton
    *ngIf="loading && !itens.length"
    rotulo="Carregando o de-para de serviço e produto">
  </app-regras-skeleton>

  <po-table
    *ngIf="!loading || itens.length"
    [p-columns]="columns"
    [p-items]="itens"
    [p-actions]="tableActions"
    [p-loading]="loading || loadingMore"
    [p-sort]="true"
    [p-striped]="true"
    [p-height]="tableHeight"
    [p-show-more-disabled]="!hasMore"
    (p-show-more)="carregarMais()">
  </po-table>

</div>

<po-modal
  #formModal
  [p-title]="modalTitle"
  p-size="md"
  [p-primary-action]="modalPrimaryAction"
  [p-secondary-action]="modalSecondaryAction">

  <div class="regras-form" [formGroup]="formGroup">

    <div class="po-row" *ngIf="duplicando">
      <small class="po-md-12 po-font-text-small">
        Cópia do de-para <b>{{ editing?.codigo }}</b>.
      </small>
    </div>

    <div class="po-row">
      <po-select
        class="po-md-12"
        p-label="Tipo de de-para"
        [p-options]="tipoOptions"
        formControlName="tipo"
        p-required>
      </po-select>
    </div>

    <div class="po-row" *ngIf="tipoSelecionado === '2'">
      <small class="po-md-12 po-font-text-small">
        Neste tipo o destino é o <b>código LC116 equivalente</b>, não um produto —
        por isso não há busca no cadastro de produtos. Havendo mais de um código
        para a mesma origem, vale o de menor código de registro.
      </small>
    </div>

    <div class="po-row" *ngIf="tipoSelecionado === '3'">
      <small class="po-md-12 po-font-text-small">
        No produto de frete, o código de origem é <b>S</b> (Simples Nacional) ou
        <b>N</b> (regime normal).
      </small>
    </div>

    <div class="po-row">
      <po-input
        class="po-md-6"
        [p-label]="rotuloChave"
        formControlName="chave"
        [p-maxlength]="20"
        p-required>
      </po-input>

      <po-combo
        *ngIf="destinoEhProduto"
        class="po-md-6"
        [p-label]="rotuloDestino"
        p-filter-service="portalnf/regras/lookup/produto"
        p-field-label="label"
        p-field-value="value"
        [p-sort]="true"
        p-help="Digite ao menos 3 caracteres para buscar"
        name="produto"
        formControlName="produto"
        [p-required]="true"
        [p-infinite-scroll]="true">
      </po-combo>

      <po-input
        *ngIf="!destinoEhProduto"
        class="po-md-6"
        [p-label]="rotuloDestino"
        formControlName="produto"
        [p-maxlength]="15"
        p-required>
      </po-input>
    </div>

    <div class="po-row">
      <po-input
        class="po-md-8"
        p-label="Descrição"
        formControlName="descricao"
        [p-maxlength]="100">
      </po-input>

      <po-select
        class="po-md-4"
        p-label="Situação"
        [p-options]="situacaoOptions"
        formControlName="ativo"
        p-required>
      </po-select>
    </div>

    <div class="po-row" *ngIf="editing?.usrAlt">
      <small class="po-md-12 po-font-text-small regras-auditoria">
        Última alteração por <b>{{ editing?.usrAltNome || editing?.usrAlt }}</b>
        em {{ formatarData(editing?.dtAlt) }} às {{ editing?.hrAlt }}.
      </small>
    </div>

  </div>

</po-modal>
